import React from "react";
import { Col, Container, Form, FormGroup, Row } from "react-bootstrap";
import { useFormik } from "formik";
import * as Yup from "yup";

const Contact = () => {

    const formik: any = useFormik({
        initialValues: {
            name: '',
            email: '',
            text: '',
            comments: ''
        },
        validationSchema: Yup.object({
            name: Yup.string().required("Please Enter Your Name"),
            email: Yup.string().email().matches(/^(?!.*@[^,]*,)/).required("Please Enter Your Email"),
            text: Yup.string().required("Please Enter Your Text"),
            comments: Yup.string().required("Please Enter Your Comments"),
        }),
        onSubmit: (values: any) => {
            // console.log('newContact', newContact);
            formik.resetForm();
        }
    });
    return (
        <React.Fragment>
            <section className="section" id="contact">
                <Container>
                    <Row className="justify-content-center">
                        <Col lg={7}>
                            <div className="contact-head text-center">
                                <h4 className="title-heading text-uppercase">Contact us</h4>
                                <p className="title-desc text-muted mt-3">Find the perfect business template for any type of business size. Browse be websites created for small businesses, such as online service providers.</p>
                            </div>
                        </Col>
                    </Row>
                    <Row className="mt-4 vertical-content">
                        <Col lg={12}>
                            <Row className="mt-5">
                                <Col lg={4}>
                                    <div className="contact-info">
                                        <div className="mt-3">

                                            <h6 className="text-muted">Email Address</h6>
                                            <p>Example@abc.com</p>
                                        </div>

                                        <div className="mt-4">
                                            <h6 className="text-muted">Phone number</h6>
                                            <p>+1-903-929-5705 , +1-631-705-0194</p>
                                        </div>

                                        <div className="mt-4">
                                            <h6 className="text-muted">Office Address</h6>
                                            <p>3961 Melville Street <br />
                                                Bruceton, TN 38317</p>
                                        </div>
                                    </div>
                                </Col>
                                <Col lg={8}>
                                    <div className="custom-form">
                                        <Form onSubmit={formik.handleSubmit} className="contact-form" name="myForm" id="myForm">
                                            <span id="error-msg"></span>
                                            <Row className="g-3">
                                                <Col lg={6}>
                                                    <FormGroup>
                                                        <Form.Control
                                                            type="text"
                                                            name="name"
                                                            id="name"
                                                            placeholder="Your name..."
                                                            value={formik.values.name}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            isInvalid={!!formik.errors.name}
                                                        />
                                                        {formik.errors.name && formik.touched.name ? (
                                                            <Form.Control.Feedback type="invalid">{formik.errors.name}</Form.Control.Feedback>
                                                        ) : null}
                                                    </FormGroup>
                                                </Col>
                                                <Col lg={6}>
                                                    <FormGroup>
                                                        <Form.Control
                                                            type="email"
                                                            name="email"
                                                            id="email"
                                                            placeholder="Your email..."
                                                            value={formik.values.email}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            isInvalid={!!formik.errors.email}
                                                        />
                                                        {formik.errors.email && formik.touched.email ? (
                                                            <Form.Control.Feedback type="invalid">{formik.errors.email}</Form.Control.Feedback>
                                                        ) : null}
                                                    </FormGroup>
                                                </Col>
                                                <Col lg={12}>
                                                    <FormGroup>
                                                        <Form.Control
                                                            type="text"
                                                            name="text"
                                                            id="sub"
                                                            placeholder="Your subject..."
                                                            value={formik.values.text}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            isInvalid={!!formik.errors.text}
                                                        />
                                                        {formik.errors.text && formik.touched.text ? (
                                                            <Form.Control.Feedback type="invalid">{formik.errors.text}</Form.Control.Feedback>
                                                        ) : null}
                                                    </FormGroup>
                                                </Col>
                                                <Col lg={12}>
                                                    <FormGroup>
                                                        <Form.Control
                                                            as="textarea"
                                                            name="comments"
                                                            id="comments"
                                                            rows={4}
                                                            placeholder="Your message..."
                                                            value={formik.values.comments}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            isInvalid={!!formik.errors.comments}
                                                        />
                                                        {formik.errors.comments && formik.touched.comments ? (
                                                            <Form.Control.Feedback type="invalid">{formik.errors.comments}</Form.Control.Feedback>
                                                        ) : null}
                                                    </FormGroup>
                                                </Col>
                                                <Col lg={12}>
                                                    <input type="submit" id="submit" name="send" className="submitBnt btn btn-custom" value="Send Message" />
                                                </Col>
                                            </Row>
                                        </Form>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Container>
            </section>
        </React.Fragment>
    );
}

export default Contact;